import { components } from "react-select";
import {
  PettyWorkStatus,
  pettyWorkStatusMap,
} from "features/PettyWorks/constants/petty-work.constants";

export interface PettyWorkSelectOption {
  value: number;
  label: string;
  title?: string | null;
  status?: string | null;
}

function PettyWorkStatusBadge({ status }: { status: string | undefined | null }) {
  if (!status) return null;
  const entry = pettyWorkStatusMap[status as PettyWorkStatus];
  if (!entry) return null;
  return (
    <span className={`badge bg-${entry.color}-subtle text-${entry.color} ms-1`}>
      {entry.label}
    </span>
  );
}

export function PettyWorkOption(props: any) {
  const data = props.data as PettyWorkSelectOption;
  return (
    <components.Option {...props}>
      <div className="d-flex flex-column py-1">
        <div className="d-flex align-items-center justify-content-between gap-2">
          <span className="fw-medium text-body">{data.label}</span>
          <PettyWorkStatusBadge status={data.status} />
        </div>
        {data.title?.trim() ? (
          <small className="text-muted text-truncate">{data.title.trim()}</small>
        ) : null}
      </div>
    </components.Option>
  );
}

export function PettyWorkSingleValue(props: any) {
  const data = props.data as PettyWorkSelectOption;
  return (
    <components.SingleValue {...props}>
      <span className="d-inline-flex align-items-center gap-1 min-w-0 text-truncate">
        <span className="fw-medium text-truncate">{data.label}</span>
        {data.title?.trim() ? (
          <span className="text-muted text-truncate small">· {data.title.trim()}</span>
        ) : null}
      </span>
    </components.SingleValue>
  );
}
